module.exports = __webpack_public_path__ + "img/white_desktop.65c81007.png";